module.exports = __webpack_public_path__ + "img/6542.10d60911.jpg";